import * as React from 'react';
import { useEffect, useRef } from 'react';
import cn from 'classnames';
import AirportTooltip from '../AirportTooltip/AirportTooltip';
import FlightTooltip from '../FlightTooltip/FlightTooltip';
import { useTheme } from '../../../../theme';
import { getLocale, useIsMobile } from '../../../../utils';
import { MapConfigImpl } from '../../services/Config';
import { MapV2 } from '../../services/MapV2';
import { useDispatch, useSelector } from 'react-redux';
import { getAirports, getFlights, 
// getFlightsInSky,
getHoveredAirport, getHoveredFlight, getSelectedAirport } from '../../store/flightStatus/selectors';
import { CallbacksConfig } from '../../services/Callbacks';
import { setHoveredAirport, setHoveredFlight, setSelectedAirport, setSelectedFlight } from '../../store/flightStatus/flightStatus';
import { useIataCode } from '../../../../hooks';
const Map = ({ className }) => {
    const mapRef = useRef();
    const map = useRef();
    const hoverAirportOverlayContainer = useRef();
    const selectedAIrportOverlayContainer = useRef();
    const flightTooltipOverlayContainer = useRef();
    const { Map: css } = useTheme('FlightStatus');
    const airports = useSelector(getAirports);
    const selectedAirport = useSelector(getSelectedAirport);
    const hoveredAirport = useSelector(getHoveredAirport);
    const hoveredFlight = useSelector(getHoveredFlight);
    // const departedFlights = useSelector(getFlightsInSky);
    const uniqueFlights = useSelector(getFlights);
    const isMobile = useIsMobile();
    const iata = useIataCode();
    const dispatch = useDispatch();
    const onAirportClick = (airport) => dispatch(setSelectedAirport(airport));
    const onAirportHover = (airport) => dispatch(setHoveredAirport(airport));
    const onFlightClick = (flight) => dispatch(setSelectedFlight(flight));
    const onFlightHover = (flight) => dispatch(setHoveredFlight(flight));
    const locale = getLocale();
    const config = new MapConfigImpl({
        container: mapRef.current,
        locale: getLocale(),
        accessToken: 'pk.eyJ1Ijoic2NhdC1haXJsaW5lcyIsImEiOiJjbHFieWNteHMwOTU0Mml0a3Y4bTFsYWxmIn0.5G_TN53qWDMx0aY3IeDVbw',
        center: null,
        stylesRu: 'mapbox://styles/scat-airlines/clqezpzao00gv01pj9vpc9ho2',
        stylesEn: 'mapbox://styles/scat-airlines/clqezp1bl00gs01qudjhpfkvt',
        selectedAirportOverlayContainer: selectedAIrportOverlayContainer.current,
        hoverAirportOverlayContainer: hoverAirportOverlayContainer.current,
        flightOverlayContainer: flightTooltipOverlayContainer.current,
        isMobileMode: isMobile,
        iata
    });
    const callbacks = new CallbacksConfig({
        onFlightHover,
        onFlightClick,
        onAirportHover,
        onAirportClick
    });
    useEffect(() => {
        if (!map.current && airports.length && uniqueFlights.length && config.container) {
            map.current = new MapV2(config, airports, uniqueFlights, callbacks);
        }
    }, [config, locale, map, airports, uniqueFlights, callbacks]);
    // clear active airport ( just set prop on map )
    useEffect(() => {
        if (map.current && selectedAirport === null) {
            map.current.clearActiveAirport();
        }
    }, [selectedAirport, map]);
    useEffect(() => {
        if (hoveredFlight && hoveredFlight.pathCompletion > 0 && hoveredFlight.pathCompletion < 100) {
            map.current.setHoverFlight(hoveredFlight);
        }
    }, [hoveredFlight, map]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: cn(css.mapContainer, className), ref: mapRef }),
        React.createElement(AirportTooltip, { ref: hoverAirportOverlayContainer, airport: hoveredAirport }),
        React.createElement(AirportTooltip, { ref: selectedAIrportOverlayContainer, airport: selectedAirport }),
        React.createElement(FlightTooltip, { ref: flightTooltipOverlayContainer, flight: hoveredFlight })));
};
export default Map;
